<template>

  <div class="worldpay3ds">
<!--    <div class="cardTitle">-->
<!--     -->
<!--    </div>-->
    <div class="wrap">
      <iframe :src="url" width="100%" height="550px"></iframe>
    </div>
  </div>
</template>

<script>

import helper from '../../services/helper'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

window.vm = {}

export default {
  components: {
    PulseLoader
  },
  data() {
    return {}
  },
  props: {
    url: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    process3ds: function (result) {
      this.$emit('process3ds', result)
    }
  },
  created: function(){
    vm.someComponent = this
  }
}

window.addEventListener('message', function (event) {
	let x;
	if($.type(event.data) === 'string'){
		x = JSON.parse(event.data);
	}else{
		x = event.data;
	}

  if (x.type == '3ds-error') {
    console.log('ERROR');
    vm.someComponent.process3ds('error');
  }
  if (x.type == '3ds-success') {
    console.log('SUCCESS');
    vm.someComponent.process3ds('success');
  }
}, false);
</script>

<style scoped>

  .worldpay3ds {

  }

</style>
